import { ReactNode } from 'react';

import { Field, FieldProps } from 'react-final-form';

import { TextAreaProps, TextArea } from '@cast/design-system';

import { useRffFormState } from '../hooks';
import { showErrorOnChange } from '../utils';

type Props = Omit<TextAreaProps, 'name'> & {
  name: string;
  renderError?: (error: string | string[]) => ReactNode;
  fieldProps?: Partial<FieldProps<string, any>>;
};

export const RffTextArea = ({
  fieldProps = {},
  renderError,
  ...textAreaProps
}: Props) => {
  const { mode } = useRffFormState();
  const readOnly = mode === 'view';

  return (
    <Field
      {...fieldProps}
      name={textAreaProps.name}
      render={(props) => {
        const {
          input: { onBlur, onFocus, onChange, value },
          meta,
        } = props;
        const showError = showErrorOnChange(meta);
        return (
          <TextArea
            onBlur={onBlur}
            onFocus={onFocus}
            onChange={onChange}
            value={value}
            error={
              showError ? renderError?.(meta.error) || meta.error : undefined
            }
            success={meta.touched && meta.valid}
            readOnly={readOnly}
            {...textAreaProps}
          />
        );
      }}
    />
  );
};
